"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseDigraph = parseDigraph;
const regex = /digraph([\s\S]*?)\}[\s]*?$/gm;
function parseDigraph(text) {
    const result = text.match(regex);
    return result || null;
}
//# sourceMappingURL=parse-digraph.js.map